import { useMutation, useQueryClient } from '@tanstack/react-query';

import { type CreateMediaAssetBody, createMediaAsset } from '~/services/MediaService';

import { mediaAssetQueryKeys } from './mediaQueryKeys';

/** Creates a media asset and refreshes every listing of them. */
export function useCreateMediaAsset() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: CreateMediaAssetBody) => createMediaAsset(body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: mediaAssetQueryKeys.all }),
  });
}
